import { Icon20WriteOutline } from '@vkontakte/icons';
import React, { type MouseEvent, forwardRef } from 'react';
import {
    EDIT_MENU_BUTTON_REDESIGN_ATTACH,
    EDIT_MENU_BUTTON_REDESIGN_DOCUMENT,
} from 'reactApp/appHelpers/featuresHelpers/features/editMenuButtonRedesign';
import { MenuButton } from 'reactApp/ui/ReactViewer/ViewerMenu/MenuButton/MenuButton';

const EDIT_BUTTON_TEXT = 'Редактировать';
const EDIT_COPY_BUTTON_TEXT = 'Редактировать копию';

interface Props {
    hint?: string;
    qaId?: string;
    onClick?: (evt: MouseEvent) => void;
    editCopy?: boolean;
}

export const EditMenuButton = forwardRef<HTMLDivElement, Props>(({ onClick, qaId = 'edit', hint: hintProp, editCopy }, ref) => {
    const isEditButtonRedesignEnabled = !editCopy && EDIT_MENU_BUTTON_REDESIGN_DOCUMENT;
    const isEditCopyButtonRedesignEnabled = editCopy && EDIT_MENU_BUTTON_REDESIGN_ATTACH;

    const redesignEnabled = isEditButtonRedesignEnabled || isEditCopyButtonRedesignEnabled;

    const buttonText = editCopy ? EDIT_COPY_BUTTON_TEXT : EDIT_BUTTON_TEXT;
    const hintWhenDisabled = hintProp ?? buttonText;

    const text = redesignEnabled ? buttonText : undefined;
    const hint = redesignEnabled ? undefined : hintWhenDisabled;

    return <MenuButton text={text} icon={<Icon20WriteOutline />} onClick={onClick} qaId={qaId} hint={hint} ref={ref} />;
});

EditMenuButton.displayName = 'EditMenuButton';
